import { AppEnvironment } from './environment.types';
/** Stage environment configuration */
export const environment: AppEnvironment = {
  name: 'stage',
  production: false,
  apiBaseUrl: 'https://halolite.hoganuat.com',
  reportBaseUrl: 'https://reports.hoganuat.com',
  policy_url: 'https://www.hoganassessments.com/privacy-policy',
  terms_url: 'https://identity.hoganassessments.com/Account/ViewTermsAndConditions',
  oidc: {
    issuer: 'https://hoganidentity.hoganuat.com',
    clientId: 'halo_lite',
    redirectUri: 'https://halolite.hoganuat.com/callback.html',
    silentRefreshRedirectUri: 'https://halolite.hoganuat.com/silentRenew.html',
    scope: 'openid profile halo_lite',
    requireHttps: false,
    showDebugInformation: true,
  },
};
